import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { fromDTO, sortToDTO } from './api/mapper'
import { GET_AB_TESTS_FOR_TABLE } from './api/query'
import { AbTestsForTableDTO } from './api/types'
import { AbTestsForTable, UseGetAbTests, UseGetAbTestsProps } from './types'

export const useGetAbTests = ({
  filters,
  first,
  last,
  sort,
}: UseGetAbTestsProps): UseGetAbTests => {
  const [abTests, setAbTests] = useState<AbTestsForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { loading } = useQuery(GET_AB_TESTS_FOR_TABLE, {
    onCompleted: ({ abTests: { nodes: abTests, totalCount: count } }): void => {
      if (abTests) {
        setAbTests(abTests.map((abTest: AbTestsForTableDTO): AbTestsForTable => fromDTO(abTest)))
        setCount(count)
      }
    },

    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
    },
  })

  return { abTests, count, loading }
}
